/* eslint-disable react/no-array-index-key */
import React from 'react';

function LocationGallery({ locationSection }) {
  return (
    <div className="location-gallery-section-wrap">
      <div className="image-container">
        {locationSection?.locationSliderList?.slice(0, 5)?.map((location, index) => (
          <div
            key={location?.location || location?.id || index}
            className="image-wrapper"
            >
            <img
              src={`${location?.backgroundImage?.url}`}
              alt={location?.location}
              />
            <div className="mask" />
            <div className="location">{location?.location}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LocationGallery;
